import { autoTracking } from './lib/page';
import trackDirective from './directives/trackerDirective';
import config from './config';

export default () => {
  if (typeof document === 'undefined' || typeof window === 'undefined') return;
  config.$vue.directive('track', trackDirective);
  autoTracking();
};
